var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    width: 35,
    height: 35,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.49 18.78v-1.77c0-3.19-1.26-6.24-3.52-8.49C23.72 6.26 20.67 5 17.48 5 14.3 5 11.25 6.26 9 8.52c-2.26 2.25-3.52 5.3-3.52 8.49v1.77a4.95 4.95 0 00-3.27 1.66c-.83.96-1.26 2.2-1.2 3.46a4.924 4.924 0 004.92 4.7h.45v.18c0 .15.03.29.09.43s.14.27.25.37a1.152 1.152 0 00.81.34h.9c.15 0 .3-.03.43-.09.14-.06.27-.14.37-.25.11-.1.19-.23.25-.37.06-.14.09-.28.09-.43V18.57a1.152 1.152 0 00-.34-.81c-.1-.1-.23-.19-.37-.25-.13-.06-.28-.09-.43-.09H8v-.41a9.476 9.476 0 019.47-9.21c2.47 0 4.84.96 6.61 2.68a9.465 9.465 0 012.86 6.53v.41h-.41c-.15 0-.29.03-.43.09s-.27.15-.37.25a1.152 1.152 0 00-.34.81v10.2a1.152 1.152 0 00.34.81c.1.11.23.19.37.25.14.06.28.09.43.09h.91c.15 0 .3-.03.43-.09.14-.06.27-.14.38-.25.1-.1.19-.23.25-.37.06-.14.09-.29.09-.44v-.18h.48a4.897 4.897 0 003.49-1.44c.45-.46.82-1 1.07-1.6a5 5 0 00.37-1.88 4.96 4.96 0 00-.36-1.78c-.22-.56-.55-1.08-.96-1.53-.41-.45-.9-.81-1.45-1.09-.54-.27-1.13-.44-1.74-.49z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentAudio);
export default __webpack_public_path__ + "static/media/recentAudio.0e41a801.svg";
export { ForwardRef as ReactComponent };